<div class="flex justify-between pl-4 mb-4">
  <h1>Agencies</h1>
  <lib-button
    [cssType]="'btn-primary'"
    [icon]="'rightarrow'"
    [text]="'Add Agency'"
    [size]="'large'"
    (click)="addAgency()"
  ></lib-button>
</div>
<lib-ui-grid class="pt-3" [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>
